import script from "./RegionSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionSelection.vue?vue&type=script&setup=true&lang=js"

import "./RegionSelection.vue?vue&type=style&index=0&id=f6cc9728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6cc9728"]])

export default __exports__